import React from 'react'
import { Link } from 'react-router-dom'
import { get_promotion_prize } from '../../../utils'

const AdCardLayout = (props) => {
  let { greetings, card } = props
  return (
    <>
      <div className='container'>
        <div
          className='row justify-content-center align-content-center mt-3'
          style={{ width: '100vw', height: '80vh' }}
        >
          <div className='col-md-12 d-flex  justify-content-end align-items-center mb-5 mt-5 flex-column'>
            <div className='row flex-column m-2'>
              <h5>
                {/* {" "}
					Greetings, this Electronic Ad Card (EAC) from eksplode.com has been
					sent to you from{" "}
					{card.member_user.first_name +
						" " +
						card.member_user.last_name +
						" "}{" "}
					({card.member_user.email}). If you elect to purchase the
					product/service shown and described below, a portion of the sales will
					be awarded to{" "}
					{card.member_user.first_name + " " + card.member_user.last_name + " "}{" "} */}
                {greetings}
              </h5>
            </div>
          </div>
          <div className='col-sm-3 d-flex justify-content-center align-items-center'>
            <img
              src={card?.product?.product_images?.[0]?.image}
              alt='Product'
              className='img-fluid'
              // style={{ height: "90vh" }}
            />
          </div>
          <div className='col-sm-3  justify-content-start align-content-center flex-column'>
            <div className='row flex-column mt-5 m-2'>
              <h3 className='text-dark mb-2'>{card.product.product_name}</h3>
              <p>{card.product.product_discription}</p>
            </div>

            <div className='row flex-column m-2'>
            
              <a href={'/product' + card.shareable_link.split('/product')[1]}>
                {card.shareable_link}
              </a>
            </div>
          </div>
          <div className='col-sm-3 d-flex justify-content-start align-content-center flex-column '></div>

          <div className='col-sm-3 d-flex justify-content-start align-content-center flex-column '>
            <div className='row flex-column m-2 mt-5 '>
              <h3 className='text-dark mb-2'>Expiry</h3>
              <p>{new Date(card.expiry_date).toDateString()}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default AdCardLayout
